import { observer } from "mobx-react";
import { Modal } from "react-bootstrap";
import { ApiResponse, IModal } from "../../stores/index.d";
import { useCallback, useEffect, useState } from "react";
import { ShowAlert } from "../../utils/functions";
import { useStores } from "../../stores/root-store";
import { useAuth } from "../../contexts/auth-context";
import { useNavigate } from "react-router-dom";

const RegisterPage = observer(({ show, setShowModal }: IModal) => {
  const { authStore } = useStores();
  const { register } = authStore;
  const { setAuth } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [surname, setSurname] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [passWord, setPassword] = useState("");
  const [isFormValid, setIsFormValid] = useState(false);

  useEffect(() => {
    setIsFormValid(
      firstName &&
        surname &&
        email &&
        phoneNumber &&
        passWord &&
        passWord.length > 5
        ? true
        : false
    );
  }, [firstName, surname, email, phoneNumber, passWord]);

  const submitCallback = (res: ApiResponse<string>) => {
    const { data, isSuccess, message } = res;
    if (isSuccess && data) {
      setAuth(data);
      setShowModal(false);
      navigate("/");
      ShowAlert.Success("Registration successful and logged in.");
    } else ShowAlert.Error(message);
  };

  const handleFormSubmit = useCallback(() => {
    if (!isFormValid)
      ShowAlert.Error("Please make sure all the fields are entered.");
    else {
      register(
        { id: "", email, firstName, surname, phoneNumber, passWord },
        submitCallback
      );
    }
  }, [firstName, surname, email, phoneNumber, passWord, isFormValid, register]);

  return (
    <Modal
      show={show}
      onHide={() => setShowModal(false)}
      centered
      scrollable
      dialogClassName="modal-sm"
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <h4>Register</h4>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <div className="row">
            <div className="col-sm-12">
              <div className="panel panel-default">
                <div className="panel-body">
                  <form autoComplete="off">
                    <div className="form-floating mb-3">
                      <input
                        type="email"
                        className="form-control"
                        id="emailU"
                        placeholder="name@example.com"
                        value={email}
                        autoComplete="off"
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      <label htmlFor="emailU">Email address</label>
                    </div>
                    <div className="form-floating mb-3">
                      <input
                        type="text"
                        className="form-control"
                        id="fnU"
                        placeholder="First name"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                      />
                      <label htmlFor="fnU">First name</label>
                    </div>
                    <div className="form-floating mb-3">
                      <input
                        type="text"
                        className="form-control"
                        id="lnU"
                        placeholder="Last name"
                        value={surname}
                        onChange={(e) => setSurname(e.target.value)}
                      />
                      <label htmlFor="lnU">Last name</label>
                    </div>
                    <div className="form-floating mb-3">
                      <input
                        type="phone"
                        className="form-control"
                        id="phoneU"
                        value={phoneNumber}
                        autoComplete="off"
                        onChange={(e) => setPhoneNumber(e.target.value)}
                      />
                      <label htmlFor="emailU">Phone number</label>
                    </div>
                    <div className="form-floating">
                      <input
                        type="password"
                        className="form-control"
                        id="pwdU"
                        placeholder="Password"
                        value={passWord}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                      <label htmlFor="pwdU">Password</label>
                    </div>
                    <div className="small text-muted">
                      *minimum 6 characters length
                    </div>
                    <div className="btn-group d-flex mt-3">
                      <button
                        type="button"
                        className="btn btn-default rounded-0 flex-fill"
                        disabled={!isFormValid}
                        onClick={handleFormSubmit}
                      >
                        Register
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
});

export default RegisterPage;
